"use strict";
export default {
  state: function(invoice) {
    if (invoice.state === "draft") {
      return "received";
    } else if (invoice.state === "abandoned") {
      return "ignored";
    } else if (invoice.state === "partial_approved") {
      return "paid but unbilled";
    }
    return invoice.state;
  },
  exceptionStatus: function(invoice, account) {
    if (!invoice.active_exceptioned_item || invoice.active_exceptioned_item.state === "unsent") {
      if (this.isFactorAccount(account)) {
        return "incomplete";
      } else {
        return "exception";
      }
    } else {
      return invoice.active_exceptioned_item.state;
    }
  },
  isFactorAccount: function(account) {
    return account.hasRole("Factor");
  }
};
